import styled from 'styled-components';
import { StyledProps } from 'types/styles';
import { variant, borderRadius, space, fontSize, fontWeight, layout, flexbox, color } from 'styled-system';
import { ButtonStyled } from 'app/components/ButtonStyled';

interface Props extends StyledProps {
  variant?: string;
}

export const Wrapper = styled.div<Props>(
  {
    userSelect: 'none',
    display: 'flex',
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'start',
    button: {
      color: 'gray',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 0,
      padding: 0,
      cursor: 'pointer !important',
    },
    svg: {
      color: 'inherit',
      cursor: 'pointer !important',
    },
  },
  borderRadius,
  space,
  fontSize,
  fontWeight,
  fontWeight,
  layout,
  flexbox,
  color,
  variant({
    variants: {
      error: {
        bg: 'reds.5',
        color: 'blacks.0',
      },
      warning: {
        bg: 'yellows.4',
        color: 'blacks.0',
      },
      info: {
        bg: 'blues.4',
        color: 'blacks.0',
      },
      success: {
        bg: 'greens.5',
        color: 'blacks.0',
      },
    },
  }),
);

Wrapper.defaultProps = {
  p: 4,
  borderRadius: 2,
};

export const BtnWrapper = styled(ButtonStyled)<Props>`
  background-color: transparent;
  margin-left: 16px;
  svg {
    height: 12px;
    width: 12px;
    margin: 0;
    stroke-width: 2px;
  }
`;
